<div class="breadcrumbs flex-row flex-start-center gap-4 mr-8">
  <ng-container *ngFor="let item of items; let index = index; let last = last">
    @if (last) {
      <vdw-ellipsis-label
        class="b1 font-weight-regular breadcrumb-item active overflow-hidden"
        [class.disable]="disablePredicate(item)"
        [text]="item.data?.newName ?? (item.key?.toString() ?? '' | bmsTranslate: {count: 2})"
        [hasContent]="true"
        matTooltipPosition="below"
        (click)="navigateTo(index)"
      >
        {{ item.key?.toString() ?? '' | bmsTranslate: {count: 2} }}
        @if (item.data?.newName?.length > 0) {
          <span class="font-weight-semibold">{{ item.data.newName }}</span>
        }
      </vdw-ellipsis-label>
      @if (item.data?.isLocked) {
        <vdw-lock-icon [config]="item.data?.lockIconConfig"></vdw-lock-icon>
      }
    } @else {
      <p class="b1 font-weight-regular breadcrumb-item no-wrap" [class.disable]="disablePredicate(item)" (click)="navigateTo(index)">
        {{ item.key?.toString() ?? '' | bmsTranslate: {count: 2} }}
      </p>
      <p class="b1 font-weight-regular">/</p>
    }
  </ng-container>
</div>
